var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDataExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#F2FFFD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 12.931,
    y: 17.69,
    width: 11.559,
    height: 11.559,
    rx: 1.065,
    stroke: "#35404A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m16.727 12.963 13.971.003c.588 0 1.065.477 1.065 1.066V27.65h-1.549v3.905h-1.963l2.127 2.493H16.727a1.065 1.065 0 0 1-1.065-1.065V30.32h-1v2.664c0 1.14.924 2.065 2.065 2.065h14.505l.721.846 3.616-4.339h-1.963v-3.905h-.843V14.03c0-1.14-.924-2.064-2.064-2.065l-13.972-.003c-1.14 0-2.065.925-2.065 2.065v2.492h1v-2.492c0-.588.477-1.065 1.065-1.065zm15.879 19.593h.828l-1.49 1.788-1.525-1.788h.795v-3.905h1.392v3.905z",
    fill: "#35404A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.65 20.427h-2.027M28.65 23.865h-2.027M28.65 27.304h-2.027",
    stroke: "#35404A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.946 23.583-2.104-3.156h1.453l1.397 2.314 1.377-2.314h1.387L19.39 23.61l2.429 3.587h-1.52l-1.655-2.659-1.588 2.659h-1.454l2.344-3.615z",
    fill: "#31B59F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.949 35.119-2.614-3.064h1.38V28.15h2.39v3.905h1.397l-2.553 3.064z",
    stroke: "#31B59F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(12 12)",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataExport);
export default __webpack_public_path__ + "static/media/data-export.3d6f3d18623f43d1e61ad85aa4ee34ce.svg";
export { ForwardRef as ReactComponent };